import $ from "jquery";
import debounce from "lodash/debounce";

const SHOW_THRESHOLD = 250; // pixels
const ANIMATION_SPEED = 250;
let buttonBottom;

const showOrHideBackToTopLinks = function() {
  if($(window).scrollTop() >= SHOW_THRESHOLD) {
    $(".back-to-top:hidden").show(ANIMATION_SPEED);
  } else {
    $(".back-to-top:visible").hide(ANIMATION_SPEED);
  }
};

const preventFooterOverlap = function () {
  const pageHeight = document.body.scrollHeight;
  const windowHeight = window.innerHeight;
  const windowTopPosition = window.scrollY;
  const footerHeight = document.querySelector("footer").offsetHeight;

  const allowedHeight = pageHeight - (windowHeight + footerHeight);

  if (windowTopPosition > allowedHeight) {
    const updatedButtonBottom = buttonBottom + footerHeight - 40;
    $(".back-to-top").css("bottom", updatedButtonBottom);
  } else {
    $(".back-to-top").css("bottom", buttonBottom);
  }
};

const windowScrolled = debounce(function() {
  showOrHideBackToTopLinks();
}, 100);

const backToTopClicked = function(e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, ANIMATION_SPEED);
};

$(document).on("turbolinks:load", function() {
  if ($(".back-to-top").length === 0) { return; }
  $(window).off("scroll", windowScrolled); // Turbolinks fudge

  buttonBottom = parseInt($(".back-to-top").css("bottom").replace(/\D+/, ""));

  const $backToTopLinks = $(".back-to-top");
  if($backToTopLinks.length > 0) {
    showOrHideBackToTopLinks();
    $(window).on("scroll", windowScrolled);
    $(window).on("scroll", preventFooterOverlap);
    $backToTopLinks.on("click", backToTopClicked);
  }
});
